import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AppContext } from '../../store/AppProvider';
import { AppRoutes } from '../../utils/Constants';

export const SecuredRoute = ({ children, accessRoutes }) => {
    const { loggedInUser: { loggedIn } } = useContext(AppContext);
    const { pathname } = useLocation()
    let hasAccess = false
    if (pathname.includes('/details')) {
        hasAccess = Boolean(accessRoutes?.[AppRoutes.searchDetails] || false)
    } else {
        hasAccess = Boolean(accessRoutes?.[pathname] || false)
    }

    return (loggedIn && hasAccess) ? (children || <Outlet />) : <Navigate to={"/"} replace />
}
